import React from "react";

const PublicPartners = (props) => {
  return (
    <div className="img-box partner-img-box" key={props.partner.id}>
      <a
        href={props.partner.redirectUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={props.partner.fileURL} alt="Jen Henson ACT Prep" />
      </a>
    </div>
  );
};

export default PublicPartners;
